import { render } from "./App.vue?vue&type=template&id=53910a1d&bindings={\"section\":\"data\",\"showMenu\":\"data\",\"isDarkBg\":\"options\",\"toggleMenu\":\"options\",\"goToSection\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script